import { Component, Input } from "@angular/core";
import { Order } from "../../../orders/models/order";

import * as _ from 'lodash';
import { Router } from "@angular/router";

@Component({
    selector: 'order-tracker',
    templateUrl: './order-tracker.component.html',
    styleUrls: ['./order-tracker.component.sass'],
    standalone: false
})
export class OrderTrackerComponent {

    constructor(
        private router: Router
    ){}
    @Input() orders = new Array<Order>();
    currentIndex: number = 0;
    orderStatuses: Array<any> = [
        //{
        //    code: 'draft',
        //    position: 1
        //},
        //{
        //    code: 'submitted',
        //    position: 2
        //},
        //{
        //    code: 'received',
        //    position: 3
        //},
        //{
        //    code: 'pre-scanning-completed',
        //    position: 4
        //},
        //{
        //    code: 'verified',
        //    position: 5
        //},
        //{
        //    code: 'pending-payment',
        //    position: 6
        //},
        //{
        //    code: 'reception-failed',
        //    position: 7
        //},
        //{
        //    code: 'verification-failed',
        //    position: 8
        //},
        //{
        //    code: 'grading-completed',
        //    position: 9
        //},
        //{
        //    code: 'encapsulation-completed',
        //    position: 10
        //},
        //{
        //    code: 'proofing-completed',
        //    position: 11
        //},
        //{
        //    code: 'post-scanning-completed',
        //    position: 12
        //},
        //{
        //    code: 'paid-in-full',
        //    position: 13
        //},
        //{
        //    code: 'proofing-failed',
        //    position: 14
        //},
        //{
        //    code: 'upcharge-reviewed',
        //    position: 15
        //},
        //{
        //    code: 'upcharge-failed',
        //    position: 16
        //},
        //{
        //    code: 'shipping-failed',
        //    position: 17
        //},
        //{
        //    code: 'shipped',
        //    position: 18
        //},
        //{
        //    code: 'delivered',
        //    position: 19
        //}

        {
            code: 'draft',
            position: 0
        },
        {
            code: 'submitted',
            position: 1
        },
        {
            code: 'received',
            position: 2
        },
        {
            code: 'pre-scanning-completed',
            position: 3
        },
        {
            code: 'verified',
            position: 4
        },
        {
            code: 'grading-completed',
            position: 5
        },
        {
            code: 'encapsulation-completed',
            position: 6
        },
        {
            code: 'proofing-completed',
            position: 7
        },
        {
            code: 'post-scanning-completed',
            position: 8
        },
        {
            code: 'paid-in-full',
            position: 9
        },
        {
            code: 'shipped',
            position: 10
        },
        {
            code: 'delivered',
            position: 11
        },
        {
            code: 'pending-payment',
            position: 12
        },

        {
            code: 'reception-failed',
            position: 13
        },
        {
            code: 'verification-failed',
            position: 14
        },
        {
            code: 'proofing-failed',
            position: 15
        },
        {
            code: 'upcharge-reviewed',
            position: 16
        },
        {
            code: 'upcharge-failed',
            position: 17
        },
        {
            code: 'shipping-failed',
            position: 18
        }
    ];

    getOrdersCount(): number {
        return this.orders.length;
    }

    startSubmission() {
        this.router.navigate([`/checkout`]);
    }

    hasOrders(): boolean {
        return this.getOrdersCount() > 0;
    }

    moveForward() {
        if(this.canMoveForward()) this.currentIndex++;
    }

    canMoveForward(): boolean {
        return this.currentIndex < this.getOrdersCount();
    }

    moveBackward() {
        if(this.canMoveBackward()) this.currentIndex--
    }

    canMoveBackward(): boolean {
        return this.currentIndex > 0;
    }

    getOrderStatusPosition(): number {
        return _.find(this.orderStatuses, order => order.code == this.orders[this.currentIndex].orderStatus.code).position;
    }
}
